import { ResponseDTO } from "../types/Exercise";

export type EditorType = {
  body: string;
  answered: boolean;
  isModified?: boolean;
  atLeastOneSubmission?: boolean;
  language: string;
  submitModifiedBody: boolean;
}

export type LanguageMappingType = {
  // [key: string]: EditorType;
  languages: Record<string, EditorType>;
  editor: EditorType;
}

export type ExerciseMappingType = {
  [key: string]: LanguageMappingType;
}

export const LanguageType = {
  'C#': 'csharp',
  'C++': 'cpp',
  'Java': 'java',
  'Python': 'python'
};

export const ThemeType = {
  'Visual Studio Dark': 'vs-dark',
  'Visual Studio Light': 'vslight',
  'High Contrast': 'hc-black',
}


const generateSampleCode = (language: string) => {
  switch (language) {
    case LanguageType["C#"]:
      return `using System;

public class HelloWorld
{
    public static void Main(string[] args)
    {
        Console.WriteLine ("Hello World");
    }
}`;
    case LanguageType["C++"]:
      return `#include <iostream>

int main()
{
    std::cout<<"Hello World";

    return 0;
}`;
    case LanguageType.Java:
      return `class Main {
  public static void main(String[] args) {
      System.out.println("Hello World");
  }
}`;
  }
}

const generateDefaultEditorType = (language: string, response: ResponseDTO | null, defaultCode: string | null): EditorType => {
  return {
    body: response ? response.body : (defaultCode ?? generateSampleCode(language)),
    answered: !!response,
    isModified: false,
    atLeastOneSubmission: response?.atLeastOneSubmission ?? false,
    language: response?.language ?? null,
    submitModifiedBody: false
  } as EditorType
}

export const generateDefaultCodeMapping = (response: ResponseDTO | null, defaultCode: string | null): LanguageMappingType => {
  const codeMappingType = {
    editor: {},
    languages: {},
  } as LanguageMappingType;
  Object.keys(LanguageType).forEach((key) => {
    const language = LanguageType[key as keyof typeof LanguageType];
    codeMappingType.languages[language] = generateDefaultEditorType(language, response, defaultCode);
  })
  codeMappingType.editor = generateDefaultEditorType('', response, defaultCode);

  return codeMappingType;
}